import { defineMessage, IntlShape } from 'react-intl'

import { MessageToken } from '../../models/messages/Tokens'

export function getLabelFromToken(token: MessageToken) {
  switch (token) {
    case MessageToken.CLIENT_FIRST_NAME:
      return defineMessage({
        defaultMessage: 'Client Name',
        description: 'Label for client name token',
      })
    case MessageToken.NEXT_SESSION_DATETIME:
      return defineMessage({
        defaultMessage: 'Next Session Date',
        description: 'Label for next session date token',
      })
    case MessageToken.BOOKING_LINK:
      return defineMessage({
        defaultMessage: 'Booking Link',
        description: 'Label for booking link token',
      })
    case MessageToken.DATE_TIME_72_HOURS:
      return defineMessage({
        defaultMessage: 'Date & time 72 hours later',
        description: 'Label for date & time 72 hours later token',
      })
  }
}

export function convertTokenMessageToHtml(message: string, intl: IntlShape) {
  return message
    .replaceAll(/{{token:(.+?)}}/g, (match, name) => {
      if (!Object.values(MessageToken).includes(name as MessageToken)) {
        return match
      }
      return `<token label="${intl.formatMessage(getLabelFromToken(name as MessageToken))}" name="${name}"></token>`
    })
    .split('\n')
    .map((line) => `<p>${line}</p>`)
    .join('')
}

export function convertTemplateToText(message: string, tokens: Record<MessageToken, string>) {
  return message.replaceAll(/{{token:(.+?)}}/g, (match, name) => {
    if (!Object.values(MessageToken).includes(name as MessageToken)) {
      return match
    }
    return tokens[name as MessageToken]
  })
}

export function convertTokenToText(message: string, tokens: Record<MessageToken, string>) {
  // Replace custom <token ... name="..." ...></token> elements with the provided token values.
  // Flexible to attribute order; only requires a name attribute.
  return message.replaceAll(/<token\b[^>]*\bname="([^"]*)"[^>]*><\/token>/g, (match, name) => {
    if (!Object.values(MessageToken).includes(name as MessageToken)) {
      return match
    }
    return tokens[name as MessageToken]
  })
}

/**
 * Checks if a string contains token patterns that require rich text input
 * @param text - The text to check for token patterns
 * @returns true if token patterns are found, false otherwise
 */
export function hasTokenPattern(text: string): boolean {
  if (!text) {
    return false
  }

  const tokenPattern = /\{\{token:[^}]+\}\}/
  const customTokenPattern = /<token\s+name="[^"]*"\s+label="[^"]*"><\/token>/
  return tokenPattern.test(text) || customTokenPattern.test(text)
}
